import { getLocationPathname } from 'core/utilities';
import { matchPath } from 'react-router-dom';

/**
 * Has the responsibility of checking if the router is the equal path and
 * matches correctly the pathname.
 *
 */
export function isExactRouter(path: string) {
  const match = getMatchSelector(path);

  return match?.isExact;
}

/**
 * Return match object from path current
 *
 */
export function getMatchSelector(path: string) {
  const match = matchPath(getLocationPathname(), {
    path: path,
    exact: true,
  });

  return match;
}
